<div class="flex flex-col h-full">
  <div
    class="flex items-center justify-center shrink-0 bg-primary p-4 border border-primary"
  >
    <img
      src="/assets/icons/exosource-logo.png"
      width="33"
      height="32"
      alt="logo"
    />
  </div>
  <div class="flex-1 px-2 py-4 flex flex-col items-center gap-2">
    <button
      class="flex items-center justify-center cursor-pointer p-3 w-full rounded-lg border transition-colors duration-150"
      [routerLink]="['/']"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: true }"
      #rlaHome="routerLinkActive"
      [ngClass]="rlaHome.isActive
        ? 'bg-surface-50 text-surface-900 border-surface-100'
        : 'bg-transparent border-transparent text-surface-600 hover:bg-surface-50 hover:text-surface-900 hover:border-surface-100'"
    >
      <i class="pi pi-list-check text-xl! leading-normal!"></i>
    </button>

    <p-overlaybadge
      [severity]="openedTimesheets().length ? 'danger' : 'secondary'"
    >
      <button
        class="flex items-center justify-center cursor-pointer p-3 w-full rounded-lg border transition-colors duration-150"
        [routerLink]="['timesheets']"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: true }"
        #rlaTimesheets="routerLinkActive"
        [ngClass]="rlaTimesheets.isActive
        ? 'bg-surface-50 text-surface-900 border-surface-100'
        : 'bg-transparent border-transparent text-surface-600 hover:bg-surface-50 hover:text-surface-900 hover:border-surface-100'"
      >
        <i class="pi pi-calendar-clock text-xl! leading-normal!"></i>
      </button>
    </p-overlaybadge>

    <button
      class="flex items-center justify-center cursor-pointer p-3 w-full rounded-lg border transition-colors duration-150"
      [routerLink]="['/settings']"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: true }"
      #rlaSettings="routerLinkActive"
      [ngClass]="rlaSettings.isActive
        ? 'bg-surface-50 text-surface-900 border-surface-100'
        : 'bg-transparent border-transparent text-surface-600 hover:bg-surface-50 hover:text-surface-900 hover:border-surface-100'"
    >
      <i class="pi pi-cog text-xl! leading-normal!"></i>
    </button>
  </div>
  <div class="px-4 pt-4 pb-6 flex flex-col items-center gap-4">
    <hr class="w-full border-t border-0 border-surface-200" />
    <app-theme-switcher class="w-full" />
    <a class="flex items-center justify-center">
      <p-avatar
        [image]="userPhotoUrl() ?? undefined"
        shape="circle"
        class="w-8 h-8 rounded-full cursor-pointer"
      />
    </a>
  </div>
</div>
